import { Button } from "@mui/material";
import {
  BooleanField,
  DateField,
  FunctionField,
  ReferenceField,
  Show,
  SimpleShowLayout,
  useShowController,
} from "react-admin";
import { formatDate } from "../../utils/common";
import { statusToChinese } from "../../utils/driver-schedule";
import { useNavigate } from "react-router-dom";

export const DriverScheduleShow = (props: any) => {
  const navigate = useNavigate();
  const { record } = useShowController(props);
  if (!record) return null;
  const handleGoToCalendar = () => {
    if (record && record.driver) {
      navigate(`/calendar?driverId=${record.driver}`);
    }
  };

  return (
    <Show {...props}>
      <SimpleShowLayout>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoToCalendar}
          style={{ marginTop: "16px" }}
        >
          查看日历
        </Button>
        <ReferenceField
          reference="fleetAssignments"
          label="司机"
          source="driver"
        >
          <FunctionField
            render={(record: any) =>
              `${record.truck.licensePlate ?? record.truck.plate} - ${
                record.driver === null ? "未知司机" : record.driver.name
              } - ${record.source ?? `线下收集`}`
            }
          />
        </ReferenceField>
        <FunctionField
          label="车队"
          render={(record: any) => {
            const fleets =
              record.fleets?.map((fleet: any) => fleet.name).join(", ") ||
              "未知车队";
            return fleets;
          }}
        />
        <FunctionField
          label="所属公司或部门"
          render={(record: any) => {
            if (record.organizations && record.organizations.length > 0) {
              return record.organizations.join(", ");
            } else {
              return "未知";
            }
          }}
        />
        <FunctionField
          label="上次更新"
          render={(record: any) =>
            `${record.updatedBy ?? ""}更新于${formatDate(record.updatedAt)}`
          }
        />
        <FunctionField
          label="始发站"
          render={(record: any) =>
            `${record.origin?.province || ""} ${record.origin?.city || ""} ${
              record.origin?.district || ""
            }`
          }
        />
        <FunctionField
          label="终点站"
          render={(record: any) =>
            `${record.destination?.province || ""} ${
              record.destination?.city || ""
            } ${record.destination?.district || ""}`
          }
        />
        <DateField source="departureDate" label="出发日期" />
        <DateField source="arrivalDate" label="到达日期" />
        <FunctionField
          label="状态"
          render={(record: any) => statusToChinese(record.status)}
        />
        <BooleanField source="isReturnTrip" label="为返程路线" />
      </SimpleShowLayout>
    </Show>
  );
};
